// Utilities to normalize and persist cart data
const CART_KEY = 'cart';

export function normalizeCart(input) {
  if (!input) return [];
  if (Array.isArray(input)) {
    return input.map((ci) => ({
      itemId: String(ci.itemId ?? ci.item ?? ci.id ?? ''),
      qty: Number(ci.qty ?? ci.qty === 0 ? ci.qty : ci.quantity ?? 0) || 0,
    }));
  }
  if (typeof input === 'object') {
    return Object.entries(input).map(([itemId, qty]) => ({ itemId: String(itemId), qty: Number(qty) || 0 }));
  }
  return [];
}

export function toCartArray(map) {
  if (!map || typeof map !== 'object') return [];
  return Object.entries(map).map(([itemId, qty]) => ({ itemId, qty: Number(qty) || 0 }));
}

export function mapFromArray(arr) {
  const map = {};
  if (!Array.isArray(arr)) return map;
  for (const it of arr) {
    const id = String(it.itemId ?? it.item ?? it.id ?? '');
    map[id] = Number(it.qty ?? it.quantity ?? 0) || 0;
  }
  return map;
}

export function saveCart(arr) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(Array.isArray(arr) ? arr : []));
  } catch (e) {
    // ignore storage errors
  }
}

export function loadCart() {
  try {
    const s = localStorage.getItem(CART_KEY);
    return s ? JSON.parse(s) : [];
  } catch (e) {
    return [];
  }
}

export default {
  CART_KEY,
  normalizeCart,
  toCartArray,
  mapFromArray,
  saveCart,
  loadCart,
};
